import React from 'react';

const DownArrow = () => (
  <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.52449 4.77458L7.78515 1.33688C8.07162 1.03486 8.07162 0.537418 7.78515 0.235398C7.49868 -0.066622 7.02686 -0.066622 6.74039 0.235398L4.00211 3.11347L1.26382 0.226515C0.977356 -0.075505 0.505529 -0.075505 0.219063 0.226515C0.0758294 0.377525 0 0.581833 0 0.777258C0 0.981566 0.0758294 1.17699 0.219063 1.328L3.47973 4.7657C3.76619 5.0766 4.23802 5.0766 4.52449 4.77458Z"
      fill="#048802"
    />
  </svg>
);

export default DownArrow;
